// /v1/openai/get-description

import config from 'config';
import utils from 'utils';

const baseUrl = config.api[window.location.hostname].baseUrl;

// onUsage is optional so /moderation keeps calling this exactly as it did; only
// Auto Mod, which shows what is left of the daily allowance, asks for the token
// count this call spent.
const getResponse = (system, prompt, onUsage) => {
  return fetch(`${baseUrl}/mod/v1/openai/get-description`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ system, prompt }),
  })
    .then(utils.fetch.process)
    .then(r => {
      if (typeof onUsage === 'function' && r.data.usage) {
        onUsage(r.data.usage);
      }

      return r.data.response;
    });
};

const actionsOpenAI = {
  getResponse,
};

export default actionsOpenAI;
